import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  class: "sec-main highlightD-main pb-0"
}
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "col-sm-10 mx-auto list-content" }
const _hoisted_12 = {
  key: 0,
  class: "list-banner"
}
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "board bg-white" }
const _hoisted_15 = { class: "head-row flex-grow-1 text-primary" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_17 = { class: "editor-html" }
const _hoisted_18 = { class: "frce mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "返回前頁", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "container-lg" }
const _hoisted_22 = {
  key: 0,
  class: "row mb-60"
}
const _hoisted_23 = { class: "col-11 col-md-10 mx-auto mx-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-3 text-primary" }, "精彩相片", -1)
const _hoisted_25 = { class: "row hub-space-group overflow-m row-cols-md-4 row-cols" }
const _hoisted_26 = { class: "ratio ratio-hub ratio-hub-photo" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = {
  key: 0,
  class: "small text-muted text-center mt-1"
}
const _hoisted_29 = {
  key: 1,
  class: "row"
}
const _hoisted_30 = { class: "col-11 col-md-10 mx-auto mx-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-3 text-primary" }, "精彩影片", -1)
const _hoisted_32 = { class: "row hub-space-group overflow-m row-cols-md-4 row-cols" }
const _hoisted_33 = { class: "ratio ratio-hub" }
const _hoisted_34 = ["src", "alt", "data-video-url"]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"hubGalleryModal\" tabindex=\"-1\" aria-hidden=\"true\" data-bs-backdrop=\"true\"><div class=\"modal-dialog modal-xl modal-dialog-centered\"><div class=\"modal-content text-white border-0\"><div class=\"modal-body p-0\"><div class=\"hub-gallery-main position-relative\"><div class=\"ratio ratio-hub\"><img id=\"hubGalleryMainImg\" src=\"\" alt=\"\" class=\"w-100 d-block\"></div><button type=\"button\" class=\"hub-gallery-prev btn btn-sm position-absolute top-50 translate-middle-y\"></button><button type=\"button\" class=\"hub-gallery-next btn btn-sm position-absolute top-50 translate-middle-y\"></button></div><div class=\"hub-gallery-caption text-center\" id=\"hubGalleryCaption\"></div><div class=\"hub-gallery-thumbs d-flex overflow-auto py-2 px-1 gap-2\" id=\"hubGalleryThumbs\"></div></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      (_ctx.item)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("nav", _hoisted_5, [
                  _createElementVNode("ol", _hoisted_6, [
                    _createElementVNode("li", _hoisted_7, [
                      _createVNode(_component_router_link, {
                        to: "/",
                        title: "首頁"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("首頁")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: "/startupHub?tab=highlights",
                        title: "社創基地"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("社創基地")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.item.name), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.item.file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("img", {
                          src: _ctx.item.file.path,
                          class: "img-fluid",
                          alt: _ctx.item.name
                        }, null, 8, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.item.name), 1),
                    _hoisted_16,
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.item.description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_router_link, {
                      to: "/startupHub?tab=highlights",
                      class: "btn-anchor back",
                      "aria-label": "返回前頁"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.item && ((_ctx.item.images && _ctx.item.images.length > 0) || (_ctx.item.videos && _ctx.item.videos.length > 0)))
                  ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        (_ctx.item.images && _ctx.item.images.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                _createElementVNode("div", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.images, (img, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "col mb-3 px-md-2 px-1"
                                    }, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("img", {
                                          src: img.path,
                                          alt: img.alt,
                                          class: "img-fluid"
                                        }, null, 8, _hoisted_27)
                                      ]),
                                      (img.alt)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(img.alt), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.item.videos && _ctx.item.videos.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("div", _hoisted_32, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.videos, (video, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "col mb-3 px-md-2 px-1"
                                    }, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("img", {
                                          src: _ctx.toThumbnailUrl(video),
                                          alt: '影片 ' + (index + 1),
                                          class: "img-fluid",
                                          role: "button",
                                          "data-video-url": _ctx.toEmbedUrl(video)
                                        }, null, 8, _hoisted_34)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_35
  ], 64))
}